import useWindowDimensions from '@/hooks/UseWindowDimensions'

// Screen widths of the device types, in px, kept from material-sd: device sent to TagCommander (env_device) and
// layout of the Stripe payment form
export const breakpoints = {
  mobileMax: 769,
  tabletMin: 770,
  desktopMin: 1024,
  wideMin: 1440
}

export const isMobile = (width: number | undefined): boolean => {
  if (width === undefined) return false
  return width <= breakpoints.mobileMax
}

export const isTablet = (width: number | undefined): boolean => {
  if (width === undefined) return false
  return width >= breakpoints.tabletMin
}

export const isDesktop = (width: number | undefined): boolean => {
  if (width === undefined) return false
  return width >= breakpoints.desktopMin
}

export const isWide = (width: number | undefined): boolean => {
  if (width === undefined) return false
  return width >= breakpoints.wideMin
}

export const getDeviceType = (width: number | undefined): 'd' | 't' | 'm' => {
  if (width === undefined) return 'm'

  if (isDesktop(width)) return 'd'
  if (isTablet(width)) return 't'
  return 'm'
}

export const useBreakpoints = () => {
  const { width } = useWindowDimensions()

  return {
    width,
    isMobile: isMobile(width),
    isTablet: isTablet(width),
    isDesktop: isDesktop(width),
    isWide: isWide(width),
    deviceType: getDeviceType(width)
  }
}
